export default __webpack_public_path__ + "static/media/arrowBackBlack.40166d9e.svg";